export const ru = {
    'goals-loading-error':
        'Невозможно получить список доступных целей/сегментов. Повторите попытку через несколько минут',
    'need-some-valid-groups': 'Для получения прогноза в условии должна быть хотя бы одна выполненная цель или сегмент',
    'saving-condition-general-error': 'Не удалось сохранить условие ретаргетинга',
    'visitors-forecast-request-error': 'Прогноз количества посетителей недоступен'
};
